import { render, staticRenderFns } from "./ElectronicList.vue?vue&type=template&id=0aba1cd8&scoped=true&"
import script from "./ElectronicList.vue?vue&type=script&lang=js&"
export * from "./ElectronicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba1cd8",
  null
  
)

export default component.exports